// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddTradePartnerModalQueryVariables = Types.Exact<{
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type AddTradePartnerModalQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, mobilePhone?: string | null | undefined, isPrimary: boolean }>, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> };

export type BidPackageDetailPage_TradeFragment = { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, mobilePhone?: string | null | undefined, isPrimary: boolean }>, costCodes: Array<{ __typename?: 'CostCode', id: string }> };

export const BidPackageDetailPage_TradeFragmentDoc = gql`
    fragment BidPackageDetailPage_Trade on TradePartner {
  id
  name
  contacts {
    id
    name
    email
    mobilePhone
    isPrimary
  }
  costCodes {
    id
  }
}
    `;
export const AddTradePartnerModalDocument = gql`
    query AddTradePartnerModal($costCodes: [ID!]!) {
  tradePartners(filter: {costCodes: $costCodes}) {
    ...BidPackageDetailPage_Trade
  }
}
    ${BidPackageDetailPage_TradeFragmentDoc}`;

/**
 * __useAddTradePartnerModalQuery__
 *
 * To run a query within a React component, call `useAddTradePartnerModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddTradePartnerModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddTradePartnerModalQuery({
 *   variables: {
 *      costCodes: // value for 'costCodes'
 *   },
 * });
 */
export function useAddTradePartnerModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables> & ({ variables: AddTradePartnerModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>(AddTradePartnerModalDocument, options);
      }
export function useAddTradePartnerModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>(AddTradePartnerModalDocument, options);
        }
export function useAddTradePartnerModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>(AddTradePartnerModalDocument, options);
        }
export type AddTradePartnerModalQueryHookResult = ReturnType<typeof useAddTradePartnerModalQuery>;
export type AddTradePartnerModalLazyQueryHookResult = ReturnType<typeof useAddTradePartnerModalLazyQuery>;
export type AddTradePartnerModalSuspenseQueryHookResult = ReturnType<typeof useAddTradePartnerModalSuspenseQuery>;
export type AddTradePartnerModalQueryResult = Apollo.QueryResult<AddTradePartnerModalQuery, AddTradePartnerModalQueryVariables>;